import { Language } from '@altify/utils';

const monthNames = {
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  de: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
};

const shortMonthNames = {
  en: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
  de: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
};


export const formatDateString = (date: Date | string, language: Language) => {
  // USING Intl causes android to crash, attempting to use normal javascript date object
  // const formattedDate = new Intl.DateTimeFormat(['ban', 'id']).format(date);

  const formattedDate = date instanceof Date ? date : new Date(date);
  // produces date in 'd/m/yyyy' format

  // pad leading zeros if day/month < 10
  const days = formattedDate.getDate().toString();
  // const months = (formattedDate.getMonth() + 1).toString();
  const years = formattedDate.getFullYear().toString();

  const paddedDate = `${days.padStart(2, '0')} ${monthNames[language][formattedDate.getMonth()]
    } ${years}`;

  return paddedDate;
};

export const formatDateStringShortMonth = (
  date: string,
  language: Language,
) => {
  // USING Intl causes android to crash, attempting to use normal javascript date object
  // const formattedDate = new Intl.DateTimeFormat(['ban', 'id']).format(date);
  const formattedDate = new Date(date);
  // produces date in 'd/m/yyyy' format

  // pad leading zeros if day/month < 10
  const days = formattedDate.getDate().toString();
  // const months = (formattedDate.getMonth() + 1).toString();
  const years = formattedDate.getFullYear().toString();

  const paddedDate = `${days.padStart(2, '0')} ${shortMonthNames[language][formattedDate.getMonth()]
    } ${years}`;

  return paddedDate;
};


export const getNextDateFromWeekday = (dayOfWeek: number) => {
  const date = new Date();

  const currentDay = date.getDay();

  // Calculate the difference in days between today and the next desired day
  const daysUntilNextDay = (dayOfWeek + 7 - currentDay) % 7 || 7;

  // Add the difference in days to the current date
  date.setDate(date.getDate() + daysUntilNextDay);

  return date.toDateString();
};

export const getNextDateFromDayOfMonth = (dayOfMonth: number) => {
  const date = new Date();

  if (date.getDate() >= dayOfMonth) {
    // If today is past the specified day, move to the next month
    date.setMonth(date.getMonth() + 1);
  }

  date.setDate(dayOfMonth);

  return date.toDateString();
};
